import { Button, Container, Divider, Group } from '@melio/penny';
import type { Plan, SubscriptionBillingCycleEnum } from '@melio/subscriptions-api';

import { ContextualFeaturesList } from './ContextualFeaturesList';
import { ContextualPlanCardHeader } from './ContextualPlanCardHeader';
import { ContextualPlanPriceSection } from './ContextualPlanPriceSection';

type ContextualPlanCardProps = {
  upsellContext: {
    capabilities: string[];
    description: string;
    actionButtonLabel?: string;
  };
  plan: Plan;
  billingCycle: SubscriptionBillingCycleEnum;
  isCurrentPlan?: boolean;
  onClick: () => void;
};

export const ContextualPlanCard = ({
  upsellContext,
  plan,
  billingCycle,
  isCurrentPlan,
  onClick,
}: ContextualPlanCardProps) => (
  <Container border="regular" paddingY="m" paddingX="m">
    <Group variant="vertical" justifyContent="space-around" height="full" spacing="l">
      <Group.Item>
        <ContextualPlanCardHeader
          title={plan.title}
          description={upsellContext.description}
          isCurrent={!!isCurrentPlan}
        />
      </Group.Item>
      <Group.Item>
        <ContextualPlanPriceSection billingCycle={billingCycle} price={plan.billingCycles['monthly'].price} />
      </Group.Item>
      <Group.Item>
        <Divider />
      </Group.Item>
      <Group.Item basis="30%">
        <ContextualFeaturesList featureCapabilities={upsellContext.capabilities} isUpgrade={!isCurrentPlan} />
      </Group.Item>
      {upsellContext.actionButtonLabel && (
        <Group.Item>
          <Button
            data-testid={`contextual-plan-card-${isCurrentPlan ? 'current' : 'upgrade'}-button`}
            isFullWidth
            label={upsellContext.actionButtonLabel}
            onClick={onClick}
            variant={isCurrentPlan ? 'tertiary' : 'primary'}
          />
        </Group.Item>
      )}
    </Group>
  </Container>
);
